import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import App from './App.vue'
Vue.config.productionTip = false
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'



window.jQuery = require('../static/jquery.min.js')
window.$ = window.jQuery
window.adapter = require('../static/adapter.min.js')
import Janus from '../static/janus.js'
window.janus = Janus
console.log(Janus)

Vue.use(VueToast);
Vue.use(VueAxios, axios)
new Vue({
  render: h => h(App),
}).$mount('#app')